import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";
import { getDefaultAuthenticatedRoute, getUserRoles } from "../../utils/authRoles";

const ConsultantAdminRouteGuard = ({ children }) => {
  const { user, isLoading } = useUser();

  if (isLoading) return null;
  if (getUserRoles(user).includes("consultant_admin")) return children;

  return <Navigate to={getDefaultAuthenticatedRoute(user)} replace />;
};

export default ConsultantAdminRouteGuard;
